/**
 * @generated SignedSource<<803e6b479eb5b21b83f60c830c98acef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type SiteUsersFilterInput = {
  isActive?: ActiveRecords | null | undefined;
  roleIds?: ReadonlyArray<string> | null | undefined;
  userSiteIsActive?: ActiveRecords | null | undefined;
};
export type SitesFilterInput = {
  isActive?: ActiveRecords | null | undefined;
  schoolYearEndsBeforeOrOn?: any | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  userId?: string | null | undefined;
};
export type SitesUsersQuery$variables = {
  sitesFilter?: SitesFilterInput | null | undefined;
  skip?: boolean | null | undefined;
  usersFilter?: SiteUsersFilterInput | null | undefined;
};
export type SitesUsersQuery$data = {
  readonly sites?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
      readonly name: string | null | undefined;
      readonly summary: string | null | undefined;
      readonly users: ReadonlyArray<{
        readonly classes: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly email: string | null | undefined;
        readonly firstName: string | null | undefined;
        readonly gradeLevels: ReadonlyArray<{
          readonly id: string;
          readonly isActive: boolean;
          readonly name: string | null | undefined;
          readonly order: number;
        } | null | undefined> | null | undefined;
        readonly id: string;
        readonly isActive: boolean;
        readonly lastName: string | null | undefined;
        readonly publicUserId: string | null | undefined;
        readonly roles: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly sites: ReadonlyArray<{
          readonly id: string;
          readonly isActive: boolean;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SitesUsersQuery = {
  response: SitesUsersQuery$data;
  variables: SitesUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sitesFilter"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "usersFilter"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v7 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 100
          },
          {
            "kind": "Variable",
            "name": "sitesFilterInput",
            "variableName": "sitesFilter"
          }
        ],
        "concreteType": "SiteNodeConnection",
        "kind": "LinkedField",
        "name": "sites",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SiteNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "filter",
                    "variableName": "usersFilter"
                  }
                ],
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicUserId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SiteNode",
                    "kind": "LinkedField",
                    "name": "sites",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GradeLevelNode",
                    "kind": "LinkedField",
                    "name": "gradeLevels",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "order",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SitesUsersQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SitesUsersQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "b256fbb2818e89a219bd6f299e9d2b50",
    "id": null,
    "metadata": {},
    "name": "SitesUsersQuery",
    "operationKind": "query",
    "text": "query SitesUsersQuery(\n  $usersFilter: SiteUsersFilterInput\n  $sitesFilter: SitesFilterInput\n  $skip: Boolean = false\n) {\n  sites(sitesFilterInput: $sitesFilter, first: 100) @skip(if: $skip) {\n    nodes {\n      id\n      summary\n      name\n      isActive\n      users(filter: $usersFilter) {\n        id\n        firstName\n        lastName\n        isActive\n        email\n        publicUserId\n        roles {\n          id\n          name\n        }\n        sites {\n          id\n          name\n          isActive\n        }\n        classes {\n          id\n          name\n        }\n        gradeLevels {\n          name\n          id\n          isActive\n          order\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "65f3652a57c77c5cc23bd1182ad2a9cd";

export default node;
